import { Carousel } from '@mantine/carousel';
import { Anchor } from '@mantine/core';
import { useUnit } from 'effector-react';
import { EmblaCarouselType } from 'embla-carousel';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'shared/lib';
import { gameHelpModalModel } from '../../model';
import cls from './game-help-modal-navigation.module.scss';

export const GameHelpModalNavigation = () => {
	const {
		t,
		i18n: { language, dir },
	} = useTranslation();

	const emblaRef = useRef<EmblaCarouselType | null>(null);

	const [navigationIds, currentId, update] = useUnit([
		gameHelpModalModel.$navigationIds,
		gameHelpModalModel.$currentId,
		gameHelpModalModel.changeCurrentId,
	]);

	const sm = useBreakpoint('sm', false);

	useEffect(() => {
		emblaRef.current?.scrollTo(navigationIds.findIndex((id) => id === currentId));
	}, [currentId]);

	return (
		<Carousel
			getEmblaApi={(embla) => {
				emblaRef.current = embla;
			}}
			emblaOptions={{
				direction: dir(language),
				dragFree: true,
				align: 'start',
			}}
			classNames={{ root: cls.navigationRoot }}
		>
			{navigationIds.map((id) => (
				<Carousel.Slide
					key={id}
					className={cls.navigationSlide}
				>
					<Anchor
						className={cls.navigationButton}
						href={`#${id}`}
						size={sm ? 'md' : 'sm'}
						data-active={id === currentId || undefined}
						onClick={() => update(id)}
					>
						{t(`game-help-modal.${id}.title`)}
					</Anchor>
				</Carousel.Slide>
			))}
		</Carousel>
	);
};
